import { render } from "./middleNumber.vue?vue&type=template&id=33a80b8c&scoped=true"
import script from "./middleNumber.vue?vue&type=script&lang=js"
export * from "./middleNumber.vue?vue&type=script&lang=js"

import "./middleNumber.vue?vue&type=style&index=0&id=33a80b8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33a80b8c"

export default script